import { jsx as _jsx } from "react/jsx-runtime";
import Empty from 'antd/es/empty';
import Typography from '../../typography';
const SidebarEmpty = ({ label }) => {
    return (_jsx("div", { style: { width: '100%' }, children: _jsx(Empty, { styles: { image: { width: 100, height: 100, marginInline: 'auto' } }, style: { marginInline: 'auto' }, description: _jsx(Typography, { elementTheme: "body3", medium: true, children: label }) }) }));
};
export default SidebarEmpty;
